// ----------------------------
// Created by Bulletproof Games
//            2021
//  www.bulletproofgames.co.uk
// ----------------------------
//
// Game Loader
//

Loader = {};
Loader.isLoaded = false;
Loader.minTimerExpired = false;
Loader.readyForSplash = false;
Loader.loadMask = undefined;
Loader.crtPercent = 0;

autoplayManager.containerName = "autoplayContainer:autoplayBackground";

Loader.initialise = function (container) {
  Loader.container = container;

  Loader.doTextMapping();
  Loader.doTranslationPhrases();

  // Setup callback functions
  resourceManager.registerLoadCompleteCallback(Loader.onLoadComplete);
  resourceManager.registerLoadProgressCallback(Loader.onLoadProgress);
  Reflex.registerEventHandler("ready", Loader.onLayoutComplete);
};

// We need to replace JACKPOT with POT in some regions
Loader.doTranslationPhrases = function () {
  if (gameController.license === "" || gameController.license === undefined) {
    gameController.license = "default";
  }

  const currentLanguage = gdk.getCurrentLanguage();
  if (currentLanguage === "en-GB") {
    gdk.addConfigValue("%OpenSansNeue_LTStd_47%", "OpenSansNeue_LTStd_47");
  } else {
    gdk.addConfigValue("%OpenSansNeue_LTStd_47%", "loadingFontNonEnGreen");
  }

  const license = gameController.license.toUpperCase();

  if (license === "DE" || license === "LT" || license === "FIN") {
    gdk.addConfigValue(
      "t_helpTitle_JackpotReels",
      "t_helpTitle_JackpotReels_alt"
    );
    gdk.addConfigValue(
      "t_helpText_JackpotReels1",
      "t_helpText_JackpotReels1_alt"
    );
    gdk.addConfigValue(
      "t_helpText_JackpotReels2",
      "t_helpText_JackpotReels2_alt"
    );
    gdk.addConfigValue(
      "t_helpText_JackpotReels4",
      "t_helpText_JackpotReels4_alt"
    );
    gdk.addConfigValue(
      "t_helpText_FireballLink5",
      "t_helpText_FireballLink5_alt"
    );
    gdk.addConfigValue("t_helpTitle_PickBonus", "t_helpTitle_PickBonus_alt");
    gdk.addConfigValue("t_helpText_PickBonus", "t_helpText_PickBonus_alt");
    gdk.addConfigValue("t_jackpotGuranteed", "t_jackpotGuranteed_alt");
    gdk.addConfigValue("t_helpText_bonusBuy", "t_helpText_bonusBuy_alt");
    gdk.addConfigValue(
      "t_helpText_JackpotFireballs",
      "t_helpText_JackpotFireballs_alt"
    );

    gdk.addConfigValue(
      "Jackpot_Reels_Logo",
      "maingame/Grand_Prize_Reels_Logo.png"
    );
  } else {
    gdk.addConfigValue("t_helpTitle_JackpotReels", "t_helpTitle_JackpotReels");
    gdk.addConfigValue("t_helpText_JackpotReels1", "t_helpText_JackpotReels1");
    gdk.addConfigValue("t_helpText_JackpotReels2", "t_helpText_JackpotReels2");
    gdk.addConfigValue("t_helpText_JackpotReels4", "t_helpText_JackpotReels4");
    gdk.addConfigValue("t_helpText_FireballLink5", "t_helpText_FireballLink5");
    gdk.addConfigValue("t_helpTitle_PickBonus", "t_helpTitle_PickBonus");
    gdk.addConfigValue("t_helpText_PickBonus", "t_helpText_PickBonus");
    gdk.addConfigValue("t_jackpotGuranteed", "t_jackpotGuranteed");
    gdk.addConfigValue("t_helpText_bonusBuy", "t_helpText_bonusBuy");
    gdk.addConfigValue(
      "t_helpText_JackpotFireballs",
      "t_helpText_JackpotFireballs"
    );

    gdk.addConfigValue("Jackpot_Reels_Logo", "maingame/Jackpot_Reels_Logo.png");
  }

  // const currentLanguage = gdk.getCurrentLanguage();
  // if (currentLanguage === "en-GB") {
  //   gdk.addConfigValue("fontReplacementLoading_Green", "loadingFontEnGreen");
  //   gdk.addConfigValue("fontReplacementLoading_Yellow", "loadingFontEnYellow");
  //   gdk.addConfigValue("fontReplacementLoading_Orange", "loadingFontEnOrange");
  //   gdk.addConfigValue("fontReplacementLoading_gbDescText", "gbDescText");
  // } else {
  //   gdk.addConfigValue("fontReplacementLoading_Green", "loadingFontNonEnGreen");
  //   gdk.addConfigValue("fontReplacementLoading_Yellow", "loadingFontNonEnYellow");
  //   gdk.addConfigValue("fontReplacementLoading_Orange", "loadingFontNonEnOrange");
  //   gdk.addConfigValue("fontReplacementLoading_gbDescText", "gbNonEnDescText");
  // }
};

Loader.doTextMapping = function () {
  const isMobile = gdk.deviceInfo.mobile;

  if (isMobile) {
    gdk.addConfigValue("textReplacementContinue", "t_TouchToContinue");
  } else {
    gdk.addConfigValue("textReplacementContinue", "t_ClickToContinue");
  }
};

Loader.onResize = function (width, height, isLandscape) {
  if (Loader.loaderBackground !== undefined) {
    var scale = Math.max(
      width / Loader.loaderBackground.texture.width,
      height / Loader.loaderBackground.texture.height
    );
    Loader.loaderBackground.scale.x = scale;
    Loader.loaderBackground.scale.y = scale;
    Loader.loaderBackground.position.x = width / 2;
    Loader.loaderBackground.position.y = height / 2;
  }
};

Loader.onLoadComplete = function (loadGroup, resources) {
  if (loadGroup === "loading") {
    Loader.progressBar = resourceManager.get(
      "loadingBarContainer:loadingProgressFill"
    );
    resourceManager.getContainer("loadingbackgroundContainer").visible = true;
    resourceManager.getContainer("backgroundContainer").visible = false;
    resourceManager.getContainer("splashContainer").visible = false;
    resourceManager.getContainer("popupContainer").visible = false;

    Loader.loadMask = resourceManager.get("loadingBarContainer:loadingMask");
    Loader.loadMask.beginFill(0xffffff);
    Loader.loadMask.drawRect(0, 0, 434, 52);
    Loader.loadMask.endFill();

    Loader.loadMask.pivot.x = 0;
    Loader.loadMask.scale.x = 0;
    Loader.progressBar.mask = Loader.loadMask;

    Loader.setLoadProgress(0);

    Reflex.registerEventHandler("layoutChange", Loader.layoutChange);

    const loadingData = gdk.getPlatformLoadingData();
    let isGamCareLogoVisible = checkForDefined(loadingData.gamCareLogo)
      ? loadingData.gamCareLogo
      : false;
    let isPreloadMessageVisible = checkForDefined(loadingData.message);
    resourceManager.get("GamCareContainerPreLoad:gamCareLogo").visible =
      isGamCareLogoVisible;
    resourceManager
      .get("GamCareContainerPreLoad:preLoadMessage")
      .setText(isPreloadMessageVisible ? loadingData.message : "");
    resourceManager.get("GamCareContainerPreLoad").visible =
      isGamCareLogoVisible ||
      (isPreloadMessageVisible && loadingData.message.length != 0);

    if (isPreloadMessageVisible && !Reflex.developerMode) {
      // YG requirement, we need to give player 5 seconds to read preloader message
      timerManager.addTimer(5000, undefined, function () {
        Loader.minTimerExpired = true;
        Loader.checkCanGoToSplash();
      });
    } else {
      Loader.minTimerExpired = true;
      Loader.checkCanGoToSplash();
    }
  }
};

Loader.layoutChange = function () {
  Loader.setLoadProgress(Loader.crtPercent);
};

Loader.onLoadProgress = function (percent, loadGroup) {
  if (loadGroup !== "loading") {
    Loader.crtPercent = percent;
    Loader.setLoadProgress(percent);
  }
};

Loader.showGameCare = function () {
  var loadingData = gdk.getPlatformLoadingData();
  let isGamCareLogoVisible = checkForDefined(loadingData.gamCareLogo)
    ? loadingData.gamCareLogo
    : false;
  let isPreloadMessageVisible = checkForDefined(loadingData.message);
  switch (layoutController.getCurrentLayout()) {
    case "landscape_mobile": {
      resourceManager.get("GamCareContainer").visible = false;
      resourceManager.get(
        "GamCareContainer_landscapeMobile:gamCareLogo"
      ).visible = isGamCareLogoVisible;
      resourceManager.get("GamCareContainer_landscapeMobile").visible =
        isGamCareLogoVisible ||
        (isPreloadMessageVisible && loadingData.message.length != 0);
      break;
    }
    case "landscape_default":
    case "portrait_default":
    case "portrait_mobile":
    default: {
      resourceManager.get("GamCareContainer_landscapeMobile").visible = false;
      resourceManager.get("GamCareContainer:gamCareLogo").visible =
        isGamCareLogoVisible;
      resourceManager.get("GamCareContainer").visible =
        isGamCareLogoVisible ||
        (isPreloadMessageVisible && loadingData.message.length != 0);
      break;
    }
  }
};

Loader.onLayoutComplete = function () {
  Loader.setLoadProgress(1);
  messageBus.subscribe("spinner:GameConfigEvent", Loader.onGameConfigEvent);

  gameData.reels = [];
  for (let i = 0; i < gameData.numReels; i++) {
    const reel = resourceManager.get("slotContainer:reelContainer:reel" + i);
    gameData.reels.push(reel);
  }
};

Loader.setStartingSymbols = function () {
  const { startingFireballs, startingSymbols } = gameData.slotConfig;
  const symbolConfig = resourceManager.getConfiguration().symbols;

  for (let i = 0; i < 6; i++) {
    const reel = resourceManager.get("slotContainer:reelContainer:reel" + i);
    const reelSymbols = startingSymbols[i].symbols;

    let symbol;
    for (let j = 0; j < 4; ++j) {
      if (j < 3) {
        symbol = +reelSymbols[j].value;

        // if blank fireball, check its value and set it
        if (symbol === symbolConfig["Symbol_Red_Fireball"].ID) {
          const fireball = startingFireballs.find(
            (fireball) => fireball.coord.reel === i && fireball.coord.row === j
          );
          const firstCashFireballId = symbolConfig["Symbol_Fireball10"].ID;
          const possibleValues = [
            10, 20, 30, 40, 50, 100, 150, 200, 250, 500, 1000, 2000, 5000,
          ];
          const index = possibleValues.indexOf(fireball.amount);
          if (index >= 0) {
            symbol = firstCashFireballId + index;
          }
        }
      } else {
        // Generate last reel positions
        // only the symbols in view are passed to us so we need to generate the pre/post apperature symbols
        symbol = Math.floor(Math.random() * 7);
      }
      reel.setReelSymbol(j, symbol);
    }
  }
  gameController.slotMachine.update(0);
};

Loader.onGameConfigEvent = function (gameConfigTask) {
  gameData.slotConfig = gameConfigTask.data.slotConfig;
  gameData.maxExposure = gameConfigTask.data.maxExposure;

  // Golden bet
  if (gameConfigTask.data.savedClientData) {
    var encoreData = gameConfigTask.data.savedClientData.meta.find(function (
      element
    ) {
      return element.name === "encore";
    });
  }

  var enableEncoreButton = encoreData && encoreData.enabled;

  if (enableEncoreButton && !gameConfigTask.data.slotConfig.promotionActive) {
    // task.data.metaValue is set to true if recovering encore game
    gameData.encoreEnabled = true;

    // Put button in the right state if not already true
    var encoreButtonLB = resourceManager.get("goldenBetToggleButton");

    if (encoreButtonLB._flags.showGoldenBetActive !== gameData.encoreEnabled) {
      encoreButtonLB.setRecovery();
    }

    let stakeController = resourceManager.getController("stakeController");

    stakeController.setStakeMultiplier(encoreData.value);
    gameController.onStakeChanged(stakeController.CurrentStake);
    stakeController.broadcastCurrentStake();
  }

  Loader.shouldSetStartingSymbols = true;

  // Link buttons to functions
  game.initialise(gameConfigTask);

  Loader.readyForSplash = true;
  Loader.checkCanGoToSplash();
};

Loader.checkCanGoToSplash = function () {
  if (Loader.readyForSplash && Loader.minTimerExpired) {
    Loader.readyForSplash = false;
    Loader.minTimerExpired = false;
    resourceManager.getContainer("loadingContainer").visible = false;
    game.goToSplash();
    Loader.isLoaded = true;
  }
};

Loader.setLoadProgress = function (percent) {
  Loader.loadMask.scale.x = percent;
};
